export default __webpack_public_path__ + "static/media/deloitte-special-use-icon-font.27460ba5.woff2";